import React, { Component } from 'react';

import { Link, withRouter } from 'react-router-dom';

import { api } from '../../../services/api';
import { authService } from '../../../services/auth';
import constants from '../../../app.constants';
import { session } from '../../../services/session';

import LoginNav from './new-login-nav';

import './terms-conditions.scss';

class TermsConditions extends Component {
  constructor(props) {
    super(props);

    this.Api = api;
    this.Auth = authService;
    this.Constants = constants;
    this.Session = session;
  }

  acceptTerms() {
    const baseUrl = constants.API_BASE_URL;
    const apiEndpoint = constants.PUBLISHER_API_ENDPOINT;
    const { orgId } = this.Session;

    // /api/v0/publishers/:orgId/terms_conditions/accept/
    const acceptTermsConditionsRoute = `${baseUrl}${apiEndpoint}${orgId}/terms_conditions/accept/`;

    this.Api.put(acceptTermsConditionsRoute)
      .then(() => {
        this.Auth.loadTermsConditions();
      })
      .then(() => {
        this.props.history.push('/v2/publisher/account/setup');
      });
  }

  rejectTerms() {
    this.Auth.logout(true);
  }

  render() {
    const { isMobile } = this.props;
    const { isOrgAdmin } = this.Session;

    const termsConditions = (
      <iframe
        title="Terms and conditions"
        src="https://static.bam-x.com/assets/pdfs/2021-narrativ-updated-terms-and-conditions.pdf"
      ></iframe>
    );

    const orgAdmin = (
      <div className="admin">
        {termsConditions}
        <div className="content-footer">
          <p>I have read and agree to the Terms & Conditions</p>
          <button className="accept" onClick={this.acceptTerms.bind(this)}>
            Agree
          </button>
          <button className="cancel" onClick={this.rejectTerms.bind(this)}>
            Cancel
          </button>
        </div>
      </div>
    );

    const orgUser = (
      <div className="user">
        <div className="terms-conditions-content">
          <div className="terms-conditions-text">
            <h1>Your account is locked until a primary user accepts the terms and conditions.</h1>
            <p>
              Please reach out to the Narrativ lead within your organization or contact us at&nbsp;
              <a href="mailto:info@narrativ.com">info@narrativ.com</a>.
            </p>
            <button className="cancel" onClick={this.rejectTerms.bind(this)}>
              Back
            </button>
          </div>
        </div>
      </div>
    );

    return (
      <div className={`terms-conditions${isMobile ? ' mobile' : ''}`}>
        <LoginNav isMobile={isMobile} />
        <div className="content">
          <div className="content-header">
            <span className="text">Sign in</span>
            <span className="line" />
          </div>
          {isOrgAdmin ? orgAdmin : orgUser}
        </div>
      </div>
    );
  }
}

export default withRouter(TermsConditions);
